// Persistencia do carrinho do cardapio publico em localStorage (tenant-scoped).
// TTL de 4h — se o cliente fecha/recarrega a aba acidentalmente, o carrinho volta;
// apos 4h descartamos pra evitar precos antigos ou produtos removidos.
import { scopedGetItem, scopedSetItem, scopedRemoveItem } from "./tenantScope";

const CART_KEY = "cart_draft";
const CART_TTL_MS = 4 * 60 * 60 * 1000;

export function saveCartDraft(items) {
  try {
    if (!Array.isArray(items) || items.length === 0) {
      scopedRemoveItem(CART_KEY);
      return;
    }
    scopedSetItem(CART_KEY, JSON.stringify({ items, savedAt: Date.now() }));
  } catch {
    // localStorage pode falhar em modo privado — ignora
  }
}

export function loadCartDraft() {
  try {
    const raw = scopedGetItem(CART_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !Array.isArray(parsed.items) || !parsed.savedAt) {
      scopedRemoveItem(CART_KEY);
      return null;
    }
    if (Date.now() - parsed.savedAt > CART_TTL_MS) {
      scopedRemoveItem(CART_KEY);
      return null;
    }
    return parsed.items;
  } catch {
    scopedRemoveItem(CART_KEY);
    return null;
  }
}

export function clearCartDraft() {
  scopedRemoveItem(CART_KEY);
}

// Remove itens cujo produto nao existe mais na lista atual.
// Preserva preco armazenado (preco que o cliente viu ao adicionar).
export function reconcileCartWithProducts(cartItems, products) {
  if (!Array.isArray(cartItems) || !Array.isArray(products) || products.length === 0) {
    return { items: cartItems || [], removed: 0, removedItems: [] };
  }
  const productIds = new Set(products.map((p) => p.id));
  const kept = cartItems.filter((it) => productIds.has(it.id));
  // `removedItems` (v1.5.413): quem chama precisa saber QUAIS sairam pra
  // distinguir "produto foi descontinuado" de "produto nao e' deste horario"
  // — a mensagem muda completamente (um some pra sempre, o outro volta as 18h).
  const removedItems = cartItems.filter((it) => !productIds.has(it.id));
  return { items: kept, removed: removedItems.length, removedItems };
}
